import { render, staticRenderFns } from "./ArrangeWorkShift.vue?vue&type=template&id=20cf9f46"
import script from "./ArrangeWorkShift.vue?vue&type=script&lang=js"
export * from "./ArrangeWorkShift.vue?vue&type=script&lang=js"
import style0 from "./ArrangeWorkShift.vue?vue&type=style&index=0&id=20cf9f46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports